/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportPakJudgmentType
 */
export interface ReportPakJudgmentType {
    /**
     * 
     * @type {object}
     * @memberof ReportPakJudgmentType
     */
    details: object;
    /**
     * 
     * @type {object}
     * @memberof ReportPakJudgmentType
     */
    sum: object;
}

export function ReportPakJudgmentTypeFromJSON(json: any): ReportPakJudgmentType {
    return ReportPakJudgmentTypeFromJSONTyped(json, false);
}

export function ReportPakJudgmentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportPakJudgmentType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'details': json['details'],
        'sum': json['sum'],
    };
}

export function ReportPakJudgmentTypeToJSON(value?: ReportPakJudgmentType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'details': value.details,
        'sum': value.sum,
    };
}


